import {ResolveFn} from '@angular/router';
import {inject} from "@angular/core";
import {ApiService} from "@app/_services/api.service";
import {map} from "rxjs";

export const extractConfigResolver: ResolveFn<any> = (route, state) => {
    const apiService = inject(ApiService);
    return apiService.getExtractConfigEntries().pipe(map(data => ({data})));
};
